export default __webpack_public_path__ + "images/error-icon_52d114.svg";